import * as Alerts_en from './Alerts.en.js';
import * as Alerts_es from './Alerts.es.js';

const AlertsTuple = [
  { type: 'Alerts', language: 'en', object: Alerts_en.default },
  { type: 'Alerts', language: 'es', object: Alerts_es.default },
];

export default AlertsTuple;
